import LoginModal from "../components/LoginModal";

export default function Landing() {
  return <LoginModal />;
}